import {SmartComponent} from "smart-component-js";

class BannerUploadComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        // this.brands = this.element.querySelector('.brands__title');
        this.dropDown = this.element.querySelector('.brands__title');
        this.brandWrapper = this.element.querySelector('.brands__wrapper');

        this.init();
    }

    openBrandWrapper() {
        this.dropDown.addEventListener('click', () => {
            this.brandWrapper.classList.toggle('hidden');
            this.dropDown.classList.toggle('rotate');
            console.log('click');

        })
    }

    init() {
        this.openBrandWrapper();
    }


}

export default BannerUploadComponent;
